import DashboardLayout from '../../../../layouts/DashboardLayout';
import { useState } from 'react';
import { DataTable } from '../../../../components/DataTable/DataTable';
import { BADGE_CLASS } from '../../interfaces/audits.interface';
import { useEffect } from 'react';
import { FaEye } from 'react-icons/fa';
import { useAudits } from '../../hooks/useAudits';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import AuditModal from '../../components/AuditModal/AuditModal';
import styles from "../../styles/styles.module.css"
import { badgeMap } from '../../interfaces/audits.interface';
import { KPI_CARDS } from '../../interfaces/audits.interface';

function Audits() {
  const {
    entities,
    setEntities,
    fetchAudit,
    loading,
    searchValue,
    setSearchValue,
    onClear,
    dataPagination,
    setPageData,
    pageData,
    dataFilters,
    setDataFilters,
    endDate,
    setEndDate,
    startDate,
    setStartDate,
    users
  } = useAudits();

  const [stats, setStats] = useState({
    totalEventos: 0,
    correctos: 0,
    fallidos: 0,
    usuariosActivos: 0,
  });
  //DataTable
  const [openModal, setOpenModal] = useState(false);
  useEffect(() => {
    fetchAudit();
    
  }, []);
  useEffect(()=>{
    console.log('userts ',users)
    setStats({
      totalEventos: entities.length,
      correctos: entities.filter((item) => item.status === true).length,
      fallidos: entities.filter((item) => item.status === false).length,
      usuariosActivos: users.filter((item) => item.enabled == true).length,
    });
  },[entities,users])
 

  const [model, setModel] = useState(null);
  function exportCSV() {
    const headers = [
      'Fecha',
      'Hora',
      'Usuario',
      'Rol',
      'Módulo',
      'Acción',
      'IP',
      'Navegador',
      'SO',
      'Estado',
    ];

    const escapeCSV = (value) => {
      if (value === null || value === undefined) {
        return '';
      }

      return `"${String(value).replace(/"/g, '""')}"`;
    };

    const lines = entities.map((item) => {
      const date = new Date(item.createdAt);

      const fecha = date.toLocaleDateString('es-MX', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });

      const hora = date.toLocaleTimeString('es-MX', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });

      return [
        fecha,
        hora,
        item.username,
        item.role,
        item.module,
        item.action,
        item.ipAddress,
        item.browser,
        item.os,
        item.status,
      ]
        .map(escapeCSV)
        .join(',');
    });

    const csv = [headers.map(escapeCSV).join(','), ...lines].join('\r\n');

    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'auditoria.csv';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }
  const columns = [
    {
      accessorKey: 'createdAt',

      header: ({ column }) => {
        const sorted = column.getIsSorted();

        return (
          <div className="date">
            <span>FECHA</span>

            <div className="date-buttons">
              {/* ESTADO INICIAL O DESCENDENTE */}
              {sorted !== 'asc' && (
                <button
                  type="button"
                  onClick={() => column.toggleSorting(false)}

                  className="date-button"
                >
                  <FaChevronDown size={18} />
                </button>
              )}

              {/* ASCENDENTE */}
              {sorted === 'asc' && (
                <button
                  type="button"
                  onClick={() => column.toggleSorting(true)}
                  className="date-button"
                >
                  <FaChevronUp size={18} />
                </button>
              )}
            </div>
          </div>
        );
      },

      cell: ({ row }) => {
        const item = row.original;

        return (
          <div>
            <p>{new Date(item.createdAt).toLocaleDateString('es-MX')}</p>
            <p>{new Date(item.createdAt).toLocaleTimeString('es-MX')}</p>
          </div>
        );
      },
    },
    {
      accessorKey: 'username',
      header: 'USUARIO',
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div>
            <span>{item.username}</span>
            <span>{item.role}</span>
          </div>
        );
      },
    },
    {
      accessorKey: 'module',
      header: 'MÓDULO',
    },
    {
      accessorKey: 'action',
      header: 'ACCIÓN',
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div>
            <span className={badgeMap[BADGE_CLASS[item.accion]] || 'badgeQuery'}>
              {item.action}
            </span>
          </div>
        );
      },
    },
    {
      accessorKey: 'ipAddress',
      header: 'IP',
    },
    {
      accessorKey: 'status',
      header: 'ESTADO',
      cell: ({ row }) => {
        const status = row.original.status;
        return (
          <span
            className={`
          status-register
          ${status ? 'status-color-active' : 'status-color-inactive'}
        `}
          >
            {status ? 'Correcto' : 'Incorrecto'}
          </span>
        );
      },
    },
    {
      accessorKey: 'detalle',
      header: 'DETALLE',
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div>
            <button
              title="Ver detalle"
              onClick={() => {
                setModel(item);
                setOpenModal(true);
              }}
            >
              <FaEye className={styles.iconFaEye} />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="page-header-row">
          <div className="page-title-wrapper">
            <p className="page-subtitle">Consulta de movimientos realizados dentro del sistema.</p>
          </div>
        </div>

        {/* ── KPIs ── */}
        <div className={styles.kpiGrid}>
          {KPI_CARDS.map(({ key, label, icon: Icon, colorClass }) => (
            <div key={key} className={styles.kpiCard}>
              <div className={`${styles.kpiIcon} ${colorClass}`}>
                <Icon />
              </div>
              <div className={styles.kpiInfo}>
                <span className={styles.kpiValue}>{stats[key]}</span>
                <span className={styles.kpiLabel}>{label}</span>
              </div>
            </div>
          ))}
        </div>

        {/* ── Tabla ── */}
        <DataTable
           columns={columns}
          data={entities}
          searchPlaceholder="Buscar log..."
          pageSize={4}
          loading={loading}
          emptyMessage="No hay registros"
          onRowClick={(data) => {}}
          showSearch={true}
          showPagination={true}
          onSearch={() => fetchAudit()}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          showCreate={false}
          setOpenModal={setOpenModal}
          onClear={() => onClear()}
          showFilters={true}
          dataFilters={dataFilters}
          setDataFilters={setDataFilters}
          numberFilters={3}
          showCalendar={true}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          dataPagination={dataPagination}
          setPageData={setPageData}
          pageData={pageData}
        />
        {openModal && <AuditModal model={model} onClose={() => setOpenModal(false)} />}
      </div>
    </DashboardLayout>
  );
}

export default Audits;
